import React from 'react';

import './MaintenancePage.scss';

const MaintenancePage = () => (
  <main className="maintenance-page" role="alert" aria-live="assertive">
    <section className="maintenance-page__card">
      <div className="maintenance-page__status" aria-hidden="true">
        <span />
        Servicio en pausa
      </div>
      <div className="maintenance-page__mark" aria-hidden="true">↻</div>
      <h1>Página en mantenimiento</h1>
      <p>
        Estamos resolviendo un inconveniente técnico. Probá de nuevo en unos minutos.
      </p>
      <button type="button" onClick={() => window.location.reload()}>
        Volver a intentar
      </button>
      <small>Gracias por tu paciencia.</small>
    </section>
  </main>
);

export default MaintenancePage;
